import * as types from '../types'
import * as assetApi from '../../api/core/assets.dd'
import { setPriority } from 'os';
import { allResolved } from 'q';
import { store } from '../store';
import Vue from 'vue'

const state = {
  allGroups:[],
  allGroupsMeta:{pagination:{}},
  allTypes:[],
  selectedGroup:null,
  selectedAsset: null,
  selectedAssetLastUpdate:null, // for curret position and value purposes.. DONT USE FOR MUTATION
  allAssets: [],
  allUnitTypes:[],
  allDataFieldTypes:[],
  selectedAssetTimeSerie: null,
  selectedAssetProcessedEvents:[],
  selectedAssetProcessedEventsMeta:null,
  assetMapUpdaterStarted: false,
  mapAssets:[],
  assetsSearch: [],
  assetsSearchMeta:[],
  selectedAssetProcessedActions: [],
  assetRoutes:[],
  allCustomFields:[],
  allCustomFieldTypes:[],
  assetSelectionFilter: null,
  assetGroupCustomFields: null,
  hiddenAssetGroups: [],
  assetLocations: [],
  assetLocationsMeta:{pagination:{}},
  unitTypeDataFieldStatuses:[],
  unitTypeDataFields:[],
  assetGeoZoneEvents:[],
  assetGeoZoneEventsMeta: {pagination:{}},
  assetGroupGeoZoneEvents:[],
  assetGroupGeoZoneEventsMeta: {pagination:{}},
  assetDossierItems:[],
  assetDossierItemsMeta:{pagination:{}}

}
 
const getters = {
  [types.ASSET_GROUPS]: (state) => {
    return state.allGroups
  },
  [types.ASSET_GROUPS_META]: (state) => {
    return state.allGroupsMeta
  },  
  [types.ASSET_DOSSIER_ITEMS]: (state) => {
    return state.assetDossierItems
  },
  [types.ASSET_DOSSIER_ITEMS_META]: (state) => {
    return state.assetDossierItemsMeta
  },  
  [types.ASSET_GROUP_CUSTOM_FIELDS]: (state) => {
    return state.assetGroupCustomFields
  },
  [types.ASSET_SELECTION_FILTER]: (state) => {
    return state.assetSelectionFilter
  },
  [types.ASSET_TYPES]: (state) => {
    return state.allTypes
  },  
  [types.UNIT_TYPES]: (state) => {
    return state.allUnitTypes
  }, 
  [types.UNIT_TYPE_DATA_FIELDS]: (state) => {
    return state.unitTypeDataFields
  },
  [types.ASSET_ROUTES]: (state) => {
    return state.assetRoutes
  },
  [types.ASSET]: (state) => {
    return state.selectedAsset
  },
  [types.ASSET_LAST_UPDATE]: (state) => {
    return state.selectedAssetLastUpdate
  },
  [types.ASSETS]: (state) => {
    return state.allAssets
  },
  [types.ASSETS_SEARCH]: (state) => {
    return state.assetsSearch
  },
  [types.ASSETS_SEARCH_META]: (state) => {
    return state.assetsSearchMeta
  },
  [types.MAP_ASSETS]: (state) => {
    return state.mapAssets
  },
  [types.ASSET_TIME_SERIE]: (state) => {
    return state.selectedAssetTimeSerie
  },
  [types.ASSET_PROCESSED_EVENTS]: (state) => {
    return state.selectedAssetProcessedEvents
  },
  [types.ASSET_PROCESSED_EVENTS_META]: (state) => {
    return state.selectedAssetProcessedEventsMeta
  },
  [types.ASSET_PROCESSED_ACTIONS]: (state) => {
    return state.selectedAssetProcessedActions
  },
  [types.ASSET_MAP_UPDATER_START]: (state) => {
    return state.assetMapUpdaterStarted
  },
  [types.DATA_FIELD_TYPES]:(state) => {
    return state.allDataFieldTypes
  },
  [types.MAP_ASSET_GROUPS_HIDDEN]:(state) => {
    return state.hiddenAssetGroups
  },
  [types.ASSET_LOCATIONS]:(state) => {
    return state.assetLocations
  },  
  [types.ASSET_LOCATIONS_META]:(state) => {
    return state.assetLocationsMeta
  },    
  [types.UNIT_TYPE_STATUSES_BY_DATA_FIELDS]: (state) => {
    return state.unitTypeDataFieldStatuses
  },
  [types.ASSET_GEO_ZONE_EVENTS]: (state) => {
    return state.assetGeoZoneEvents
  },
  [types.ASSET_GEO_ZONE_EVENTS_PAGINATION]: (state) => {
    return state.assetGeoZoneEventsMeta
  },        
  [types.ASSET_GROUP_GEO_ZONE_EVENTS]: (state) => {
    return state.assetGroupGeoZoneEvents
  },     
  [types.ASSET_GROUP_GEO_ZONE_EVENTS_META]: (state) => {
    return state.assetGroupGeoZoneEventsMeta
  },
    
}

const mutations = {
  [types.ASSET_GROUPS]: (state, payload) => {
    state.allGroups = payload;
  },     
  [types.ASSET_GROUPS_META]: (state, payload) => {
    state.allGroupsMeta = payload;
  },
  [types.ASSET_DOSSIER_ITEMS]: (state, payload) => {
    state.assetDossierItems = payload;
  },     
  [types.ASSET_DOSSIER_ITEMS_META]: (state, payload) => {
    state.assetDossierItemsMeta = payload;
  },
  [types.ASSET_GROUP_GEO_ZONE_EVENTS]: (state, payload) => {
    state.assetGroupGeoZoneEvents = payload;
  },  
  [types.ASSET_GROUP_GEO_ZONE_EVENTS_META]: (state, payload) => {
    state.assetGroupGeoZoneEventsMeta = payload;
  },    
  [types.ASSET_GROUP_CUSTOM_FIELDS]: (state, payload) => {
    state.assetGroupCustomFields = payload;
  },
  [types.ASSET_SELECTION_FILTER]: (state, payload) => {
    state.assetSelectionFilter = payload
  },
  [types.ASSET_TYPES]: (state, payload) => {
    state.allTypes = payload;
  },  
  [types.UNIT_TYPES]: (state, payload) => {
    state.allUnitTypes = payload;
  },    
  [types.UNIT_TYPE_DATA_FIELDS]: (state, payload) => {
    state.unitTypeDataFields = payload
  },
  [types.UNIT_TYPE_STATUSES_BY_DATA_FIELDS]: (state, payload) => {
    state.unitTypeDataFieldStatuses = payload
  },
  [types.ASSET_ROUTES]: (state, payload) => {
    state.assetRoutes = payload;
  },
  [types.ASSET]: (state, payload) => {
    state.selectedAsset = payload;
  },
  [types.ASSETS]: (state, payload) => {
    state.allAssets = payload;
  },
  [types.ASSET_LAST_UPDATE]: (state, payload) => {
    state.selectedAssetLastUpdate = payload;
  },
  [types.ASSETS_SEARCH]: (state, payload) => {
    state.assetsSearch = payload;
  },
  [types.ASSETS_SEARCH_META]: (state, payload) => {
    state.assetsSearchMeta = payload;
  },
  [types.MAP_ASSETS]: (state, payload) => {
    state.mapAssets = payload;
  },
  [types.ASSET_TIME_SERIE]: (state, payload) => {
    state.selectedAssetTimeSerie = payload;
  },
  [types.ASSET_LOCATIONS]: (state, payload) => {
    state.assetLocations = payload;
  },
  [types.ASSET_LOCATIONS_META]: (state, payload) => {
    state.assetLocationsMeta = payload;
  },
  [types.ASSET_PROCESSED_EVENTS]: (state, payload) => {
    state.selectedAssetProcessedEvents = payload;
  },
  [types.ASSET_PROCESSED_EVENTS_META]: (state, payload) => {
    state.selectedAssetProcessedEventsMeta = payload;
  },
  [types.ASSET_PROCESSED_ACTIONS]: (state, payload) => {
    state.selectedAssetProcessedActions = payload;
  },
  [types.ASSET_MAP_UPDATER_START]: (state, payload) => {
    state.assetMapUpdaterStarted = payload
  },
  [types.ASSET_MAP_UPDATER]: (state, payload) => {        
    for(let asset of payload.data){
      let index = state.mapAssets.findIndex(item => item.id == asset.id)      
      Vue.set(state.mapAssets,index,asset)   
      
      if(state.selectedAsset && state.selectedAsset.id == asset.id){        
        state.selectedAssetLastUpdate = asset.lastChange
      }
    }
  },
  [types.DATA_FIELD_TYPES]: (state, payload) => {
    state.allDataFieldTypes = payload
  },
  [types.MAP_ASSET_HIDE_GROUP]: (state, payload) => {
    //state.allDataFieldTypes = payload
    if(payload.hide){
      //let index = state.hiddenAssetGroups.findIndex(item => item.id == payload.id)      
      state.hiddenAssetGroups.push(payload.group)
      //Vue.set(state.hiddenAssetGroups,index, false)    
    }
    else{
      let index = state.hiddenAssetGroups.findIndex(item => item == payload.group)        
      state.hiddenAssetGroups.splice(index,1);
    }
  },
  [types.ASSET_GEO_ZONE_EVENTS]: (state, payload) => {
    state.assetGeoZoneEvents = payload.data
    state.assetGeoZoneEventsMeta = payload.meta
  }              
}

const actions = {
    [types.ASSET_GEO_ZONE_EVENTS]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          assetApi.assetGeoZoneEvents(payload.data, payload.params).then( (res) => {
              commit(types.ASSET_GEO_ZONE_EVENTS, res)
              resolve(res)
          }).catch((e) => {
            reject(e.data)
          })        
      })
      return p
    },     
    [types.ASSET_GEO_ZONE_EVENTS_SEARCH]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
        assetApi.assetGeoZoneEventsSearch(payload.data, payload.params).then( (res) => {
              commit(types.ASSET_GEO_ZONE_EVENTS, res)
              resolve(res)
          }).catch((e) => {
            reject(e.data)
          })        
      })
      return p
    },       
    [types.ASSET_DOSSIER_ITEMS]:  ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
        assetApi.allAssetDossierItems(payload.data, payload.params).then( (res) => {
              commit(types.ASSET_DOSSIER_ITEMS, res.data)
              commit(types.ASSET_DOSSIER_ITEMS_META, res.meta)
              resolve(res)
          }).catch((e) => {
            reject(e.data)
          })        
      })
      return p
    },       
    [types.ASSET_GROUP]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          assetApi.singleGroup(payload.data, payload.params).then((res) => {                            
              resolve(res.data)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
  },    
    [types.ASSET_GROUPS]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            assetApi.allGroups(payload.params).then((res) => {
                commit(types.ASSET_GROUPS, res.data)
                commit(types.ASSET_GROUPS_META, res.meta)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },
    [types.ASSET_GROUP_GEO_ZONE_EVENTS]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          assetApi.assetGroupGeoZoneEvents(payload.data, payload.params).then( (res) => {
              commit(types.ASSET_GROUP_GEO_ZONE_EVENTS, res.data)
              commit(types.ASSET_GROUP_GEO_ZONE_EVENTS_META, res.meta)
              resolve(res)
          }).catch((e) => {
            reject(e.data)
          })        
      })
      return p
    },        
    [types.ASSET_GROUP_CUSTOM_FIELDS]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          assetApi.allAssetGroupCustomFields(payload.data, payload.params).then((res) => {
              commit(types.ASSET_GROUP_CUSTOM_FIELDS, res.data)
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
  },
    [types.ASSET_TYPES]: ({commit}, payload) => {
        let p = new Promise( (resolve, reject) => {
          assetApi.allTypes(payload.params).then((res) => {
            commit(types.ASSET_TYPES, res.data)
            resolve()
          }).catch((e) => {
            reject(e.result)
          })
        })
        return p
    },
    [types.ASSET_ROUTES]: ({commit}, payload) => {
      let p = new Promise( (resolve, reject) => {
        
        assetApi.assetRoutes(payload.data, payload.params).then((res) => {
          commit(types.ASSET_ROUTES, res.data)
          resolve()
        }).catch((e) => {
          reject(e.result)
        })
      })
      return p
  },
    [types.UNIT_TYPES]: ({commit}, payload) => {
      let p = new Promise( (resolve, reject) => {
        assetApi.allUnitTypes(payload.params).then((res) => {
          commit(types.UNIT_TYPES, res.data)
          resolve()
        }).catch((e) => {
          reject(e.result)
        })
      })
      return p
    },      
    [types.UNIT_TYPE_DATA_FIELDS]: ({commit}, payload) => {
      let p = new Promise( (resolve, reject) => {
        assetApi.allUnitTypeDataFields(payload.data,payload.params).then((res) => {
          commit(types.UNIT_TYPE_DATA_FIELDS, res.data)
          resolve()
        }).catch((e) => {
          reject(e.result)
        })
      })
      return p        
    },   
    [types.SAVE_ASSET_GROUP]: ({commit}, payload) => {
        let p = new Promise((resolve,reject) => {
            assetApi.saveGroup(payload.data).then((res) => {                              
                resolve(res)
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },
    [types.SAVE_ASSET]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {
          assetApi.saveAsset(payload.data, payload.params).then((res) => {                              
              resolve(res)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },
    [types.SAVE_ASSET_TYPE]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {
          assetApi.saveType(payload.data).then((res) => {                              
              resolve(res)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },
    
    [types.SAVE_ASSET_GEO_ZONE_EVENT]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {          
          assetApi.saveAssetGeoZoneEvent(payload.data, payload.params).then((res) => {                              
              resolve(res)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },
    [types.DELETE_ASSET_GEO_ZONE_EVENT]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {
          assetApi.deleteAssetGeoZoneEvent(payload.data, payload.params).then((res) => {                              
              resolve(res)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },  

    [types.SAVE_ASSET_GROUP_GEO_ZONE_EVENT]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {          
          assetApi.saveAssetGroupGeoZoneEvent(payload.data, payload.params).then(() => {                              
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },   
    [types.DELETE_ASSET_GROUP_GEO_ZONE_EVENT]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {          
          assetApi.deleteAssetGroupGeoZoneEvent(payload.data, payload.params).then((res) => {                              
              resolve(res) 
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },      
     
    [types.DELETE_ASSET_GROUP]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {
          assetApi.deleteGroup(payload.data).then(() => {                              
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },    
    [types.DELETE_ASSET_TYPE]: ({commit}, payload) => {
      let p = new Promise((resolve,reject) => {
          assetApi.deleteType(payload.data).then(() => {                              
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
    },        
    [types.ASSET]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
          if(payload == null){
            commit(types.ASSET, null)
            resolve()
          }
          else{
            assetApi.oneAsset(payload.data, payload.params).then((res) => {
                commit(types.ASSET, res)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
          }
        })
        return p
    },
    [types.ASSETS]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            assetApi.allAssets(payload.data, payload.params).then((res) => {
                commit(types.ASSETS, res)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },
    [types.ASSETS_SEARCH]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          assetApi.searchAssets(payload.data, payload.params).then((res) => {
            
              if(res.data && res.meta){
                commit(types.ASSETS_SEARCH, res.data)              
                commit(types.ASSETS_SEARCH_META, res.meta)
              }
              else{
                commit(types.ASSETS_SEARCH, [])              
                commit(types.ASSETS_SEARCH_META, null)
              }
              
              resolve()
          }).catch((e) => {
            
            reject(e.result)
          })
      })
      return p
  },
  [types.MAP_ASSETS]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          assetApi.allAssets(payload.data, payload.params).then((res) => {
              commit(types.MAP_ASSETS, res)
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
  },
    [types.ASSET_TIME_SERIE]: ({ commit }, payload) => {
        if(payload == null){
          commit(types.ASSET_PROCESSED_EVENTS, null)
          return;
        }
        let p = new Promise((resolve, reject) => {
            assetApi.assetTimeSerie(payload.data, payload.params).then((res) => {
                commit(types.ASSET_TIME_SERIE, res)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },
    [types.SAVE_UNIT_TYPE_TIMESERIE]: ({ commit }, payload) => {
      
      let p = new Promise((resolve, reject) => {
          assetApi.saveUnitTypeTimeSerie(payload.data).then((e) => {            
              resolve(e)
          }).catch((e) => {
            reject(e)
          })
      })
      return p
    },      
    [types.ASSET_PROCESSED_EVENTS]: ({ commit }, payload) => {
        // if(payload == null){
        //   commit(types.ASSET_PROCESSED_EVENTS, null)
        //   return;
        // }
        let p = new Promise((resolve, reject) => {
            assetApi.assetProcessedEvents(payload.data, payload.params).then((res) => {                                
                if(res.data && res.meta){
                  commit(types.ASSET_PROCESSED_EVENTS, res.data)              
                  commit(types.ASSET_PROCESSED_EVENTS_META, res.meta)
                }
                else{
                  commit(types.ASSET_PROCESSED_EVENTS, [])              
                  commit(types.ASSET_PROCESSED_EVENTS_META, null)
                }
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },
    [types.ASSET_PROCESSED_ACTIONS]: ({ commit }, payload) => {
      
      let p = new Promise((resolve, reject) => {
          assetApi.assetProcessedActions(payload.data, payload.params).then((res) => {                
              commit(types.ASSET_PROCESSED_ACTIONS, res)
              resolve()
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
  },
  [types.ASSET_EXECUTE_ACTION]: ({ commit }, payload) => {
      
    let p = new Promise((resolve, reject) => {
        assetApi.assetExecuteAction(payload.data, payload.params).then((res) => {                            
            resolve()
        }).catch((e) => {
          reject(e.result)
        })
    })
    return p
  },
  [types.ASSET_LOCATIONS]: ({ commit }, payload) => {      
    let p = new Promise((resolve, reject) => {
        assetApi.assetLocations(payload.data, payload.params).then((res) => {     
            commit(types.ASSET_LOCATIONS, res.data)                       
            commit(types.ASSET_LOCATIONS_META, res.meta)                       
            resolve()
        }).catch((e) => {
          reject(e.result)
        })
    })
    return p
  },
  [types.ASSET_CANCEL_ACTION]: ({ commit }, payload) => {
      
    let p = new Promise((resolve, reject) => {
        assetApi.assetCancelAction(payload.data, payload.params).then((res) => {                            
            resolve()
        }).catch((e) => {
          reject(e.result)
        })
    })
    return p
  },
  [types.ASSET_MAP_UPDATER_STOP]: ({ commit, state }, payload) => {
    console.log("*** STOP ASSET UPDATE SERVICE ***")
    commit(types.ASSET_MAP_UPDATER_START, false);
  },
  [types.ASSET_MAP_UPDATER_START]: ({ commit, state }, payload) => {
      let interval = (payload.params.interval) ? payload.params.interval : 60 * 1000;
      let previousTime = payload.params.interval / 1000;
      if(previousTime < 180){
        previousTime = 180
      }      
      if(!state.assetMapUpdaterStarted ){
        commit(types.ASSET_MAP_UPDATER_START, payload.data.run);

        // assetApi.assetUpdatedPositions(previousTime, payload.params).then((data) => {
        //   previousTime = Date.now() / 1000;
        //   previousTime - 5;
        //   commit(types.ASSET_MAP_UPDATER, data);
        // })

        let handler = setInterval(function () {        
          if(!state.assetMapUpdaterStarted ){        
            clearInterval(handler)
          }
          assetApi.assetUpdatedPositions(previousTime, payload.params).then((data) => {            
            commit(types.ASSET_MAP_UPDATER, data);
          })
        }.bind(this), interval)    
      }   
    },
    [types.ASSET_MAP_UPDATER]: ({ commit }, payload) => {        
        commit(types.ASSET_MAP_UPDATER, {data: [payload]});
    },
    [types.DISCARD_PROCESSED_EVENT]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
        assetApi.discardProcessedEvent(payload.data, payload.params).then((res) => {                            
          resolve()
        }).catch((e) => {
          reject(e.result)
        })
      })
      return p
    },
    [types.SAVE_DATA_FIELD]: ({commit}, payload) => {
      let p = new Promise((resolve, reject) => {
        assetApi.saveDataField(payload.data).then((e) => {            
            resolve(e)
        }).catch((e) => {
          reject(e)
        })
      })
      return p
    },  
    [types.SAVE_DATA_FIELD_STATUS]: ({commit}, payload) => {
      let p = new Promise((resolve, reject) => {
        assetApi.saveDataFieldStatus(payload.data).then((e) => {            
            resolve(e)
        }).catch((e) => {
          reject(e)
        })
      })
      return p
    },          
    [types.ASSET_DELETE_IMAGE]: ({commit}, payload) => {
      let p = new Promise( (resolve, reject) => {        
        assetApi.deleteAssetImage(payload.data, payload.params).then((res) => {          
          resolve(res)
        }).catch((e) => {
          console.error(e)
          reject(e.result)
        })
      })
      return p
    },
    [types.SAVE_ASSET_CUSTOM_FIELDS]: ({commit}, payload) => {
      let p = new Promise( (resolve, reject) => {
        assetApi.saveAssetCustomFields(payload.data, payload.params).then((res) => {        
          resolve()
        }).catch((e) => {
          reject(e.result)
        })
      })
      return p
    },    
    [types.DATA_FIELD_TYPES]: ({commit}, payload) => {
      let p = new Promise( (resolve, reject) => {
        assetApi.allDataFieldTypes(payload.params).then((res) => {
          commit(types.DATA_FIELD_TYPES, res.data)
          resolve()
        }).catch((e) => {
          reject(e.result)
        })
      })
      return p
    },    
    [types.ASSET_SELECTION_FILTER]: ({ commit }, payload) => {        
      console.log("Dit is de groep", payload)
      commit(types.ASSET_SELECTION_FILTER, payload.data);
    },
    [types.MAP_ASSET_HIDE_GROUP]: ({ commit }, payload) => {        
      commit(types.MAP_ASSET_HIDE_GROUP, payload.data);
    },
    [types.UNIT_TYPE_STATUSES_BY_DATA_FIELDS]: ({ commit }, payload) => {

      let p = new Promise((resolve, reject) => {
            assetApi.unitTypeStatusesByDataFields(payload.data, payload.params).then((res) => {
                commit(types.UNIT_TYPE_STATUSES_BY_DATA_FIELDS, res.data)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p      
    }     
}


export default {
  state,
  getters,
  mutations,
  actions
}
